module.exports = __webpack_public_path__ + "img/notification.df55251b.svg";